import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocsComponent } from './docs.component';
import { AuthGuardService } from '@core/auth/auth-guard.service';


const routes: Routes = [
  {
    path: '',
    component: DocsComponent,
    canActivate: [AuthGuardService],
    data: {
      reuse: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
  
})
export class DocsRoutingModule { }
